export const useNotificationsStore = defineStore('notifications', {
    state: () => ({ notififcations: [] }),
    // notification example: {'message': 'message as test', level: 'warning', 'visible': true}
    getters: {
        getAllNotifications: (state) => state.notififcations,
    },
    actions: {
        makeNotification(message, level = 'info') {
            let n = { message: message, level: level, visible: true }
            this.notififcations.unshift(n)
        },
        hideNotification(n) {
            n.visible = false
        },
    },
})
